module.exports = __webpack_public_path__ + "img/sellerverificationsuccess.2fe7d646.png";